import { css, keyframes } from 'styled-components';
import { SkeletonProps } from './models';

const Loading = keyframes`
  to {
    background-position: 170% 0, 0 0;
  }
`;

export const Skeleton = css<SkeletonProps>(
  ({ isLoading }) => css`
    width: 100%;
    height: 100%;
    cursor: progress;
    background-image: linear-gradient(0.25turn, transparent, #fff, transparent), linear-gradient(#eee, #eee);
    background-repeat: no-repeat;
    background-size: 35% 100%, 100% 100%;
    background-position: -70% 0, 0 0;
    ${isLoading &&
    css`
      animation: ${Loading} 1.5s infinite cubic-bezier(0.35, 0.5, 0.4, 0.85);
    `};
  `
);
